function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-Helmet_locked_icon"
}, /*#__PURE__*/React.createElement("rect", {
  width: 256,
  height: 256
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Helmet_locked_icon",
  "data-name": "Helmet locked icon",
  clipPath: "url(#clip-Helmet_locked_icon)"
}, /*#__PURE__*/React.createElement("g", {
  id: "helmet",
  transform: "translate(13.431 10.897)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_23",
  "data-name": "Path 23",
  d: "M139.323,361.719l62.788,19.864v-20.29l-45.92-14.528A75.419,75.419,0,0,1,139.323,361.719Z",
  transform: "translate(-77.593 -188.143)",
  fill: "rgba(0,0,0,0.25)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_24",
  "data-name": "Path 24",
  d: "M328.328,469.968h19.345v19.227H328.328Z",
  transform: "translate(-180.141 -254.988)",
  fill: "rgba(0,0,0,0.25)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_25",
  "data-name": "Path 25",
  d: "M306.583,394.146h39.24v20.961h-39.24Z",
  transform: "translate(-168.343 -213.85)",
  fill: "rgba(0,0,0,0.25)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_26",
  "data-name": "Path 26",
  d: "M193.613,21.72A119.517,119.517,0,0,0,125.139,0h-.48A120.587,120.587,0,0,0,4.376,120,118.876,118.876,0,0,0,16,171.922h9.251A61.479,61.479,0,0,0,77.707,142.5a75.2,75.2,0,0,1,64.169-35.989h12.017a61.677,61.677,0,0,0,29.169-7.361l51.516-27.766A120.156,120.156,0,0,0,193.613,21.72Z",
  transform: "translate(-4.375 0)",
  fill: "rgba(0,0,0,0.25)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_27",
  "data-name": "Path 27",
  d: "M329.66,260.236h-1.331v46.337h19.345v-48.54A75.237,75.237,0,0,1,329.66,260.236Z",
  transform: "translate(-180.141 -140)",
  fill: "rgba(0,0,0,0.25)"
})), /*#__PURE__*/React.createElement("g", {
  id: "padlock",
  transform: "translate(66.83 52.637)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_28",
  "data-name": "Path 28",
  d: "M156.868,71.509a9.91,9.91,0,0,0-7.28-3h-3.424V47.958a46.148,46.148,0,0,0-14.13-33.827A46.147,46.147,0,0,0,98.207,0,46.15,46.15,0,0,0,64.379,14.131,46.149,46.149,0,0,0,50.25,47.958V68.512H46.824A10.233,10.233,0,0,0,36.548,78.79v61.66a10.232,10.232,0,0,0,10.276,10.276H149.59a10.232,10.232,0,0,0,10.278-10.276V78.789A9.9,9.9,0,0,0,156.868,71.509Zm-31.256-3H70.8V47.958a26.4,26.4,0,0,1,8.029-19.375,27.4,27.4,0,0,1,38.752,0,26.405,26.405,0,0,1,8.027,19.375Z",
  transform: "translate(-36.548)"
})));

function SvgHelmetLockedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelmetLockedIcon);
export default __webpack_public_path__ + "static/media/helmet-locked-icon.457e4823.svg";
export { ForwardRef as ReactComponent };